import { render } from "./WindProduction.vue?vue&type=template&id=7b4aeb52&scoped=true"
import script from "./WindProduction.vue?vue&type=script&lang=js"
export * from "./WindProduction.vue?vue&type=script&lang=js"

import "./WindProduction.vue?vue&type=style&index=0&id=7b4aeb52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4aeb52"]])

export default __exports__